import PropTypes from 'prop-types'
import {Form} from 'formik'
import {Flex, Text, Button, Link} from '@chakra-ui/react'
import {Trans, useTranslation} from 'react-i18next'

const TermsAndConditionsStep = ({
  isSubmitting,
  onSubmit,
  onBack,
  onCancel,
  onShowTermsModal,
}) => {
  const {t} = useTranslation('points')

  return (
    <Form>
      <Flex direction="column" gap="md">
        <Flex direction="column" gap="md">
          <Text textStyle="body-small" lineHeight="1.6">
            {t('points:connectionDrawer.steps.terms.virgin.youAgree')}
          </Text>

          <Flex
            direction="column"
            gap="sm"
            ml="4"
            p="4"
            bg="gray.50"
            borderRadius="md"
          >
            <Text textStyle="body-small" color="gray.700">
              <Trans
                t={t}
                i18nKey="points:connectionDrawer.steps.terms.virgin.termsAgreementText"
                components={{
                  MarmaladeTermsLink: (
                    <Button
                      variant="link"
                      color="primary.600"
                      textDecoration="underline"
                      onClick={onShowTermsModal}
                      p={0}
                      h="auto"
                      fontWeight="normal"
                      fontSize="inherit"
                    />
                  ),
                  VirginTermsLink: (
                    <Link
                      color="primary.600"
                      textDecoration="underline"
                      href="https://www.virginaustralia.com/au/en/fly-for-business/business-flyer/terms-conditions/"
                      isExternal
                    />
                  ),
                }}
              />
            </Text>

            <Text textStyle="body-small" color="gray.700">
              {t(
                'points:connectionDrawer.steps.terms.virgin.memberLinkingText',
              )}
            </Text>

            <Text textStyle="body-small" color="gray.700">
              <Trans
                t={t}
                i18nKey="points:connectionDrawer.steps.terms.virgin.nonMemberAgreementText"
                components={{
                  PrivacyStatementLink: (
                    <Link
                      color="primary.600"
                      textDecoration="underline"
                      href="https://www.virginaustralia.com/au/en/about-us/policies/privacy/privacy-statement-business-flyer/"
                      isExternal
                    />
                  ),
                  GroupPrivacyLink: (
                    <Link
                      color="primary.600"
                      textDecoration="underline"
                      href="https://www.virginaustralia.com/au/en/about-us/policies/privacy/privacy-policy/"
                      isExternal
                    />
                  ),
                }}
              />
            </Text>
          </Flex>
        </Flex>

        <Flex justify="space-between" mt="md">
          <Flex gap="sm">
            <Button
              variant="primary"
              onClick={onCancel}
              isDisabled={isSubmitting}
            >
              {t('points:connectionDrawer.buttons.cancel')}
            </Button>
            <Button
              variant="secondary"
              onClick={onBack}
              isDisabled={isSubmitting}
            >
              {t('points:connectionDrawer.buttons.back')}
            </Button>
          </Flex>
          <Button
            variant="primary"
            colorScheme="primary"
            onClick={onSubmit}
            isLoading={isSubmitting}
            isDisabled={isSubmitting}
          >
            {t('points:connectionDrawer.buttons.connect')}
          </Button>
        </Flex>
      </Flex>
    </Form>
  )
}

TermsAndConditionsStep.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onShowTermsModal: PropTypes.func.isRequired,
}

export default TermsAndConditionsStep
